import React, { useEffect, useState } from "react";
import Header from "../../Components/Header/Header";
import Footer from "../../Components/Footer/Footer";
import "../../assets/css/Profile.css";
import SideBar from "../../Components/SideBar/SideBar";
import { Link } from "react-router-dom";
import TopBar from "../../Components/SideBar/TopBar";
import { cart1, notFound, no_image_product_details } from "../../constant";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight, faXmark } from "@fortawesome/free-solid-svg-icons";
import { GetAllWishList, PostWishListDelete } from "../../network/Network";
import { useDispatch, useSelector } from "react-redux";
import Skeleton from "react-loading-skeleton";
import NoRecord from "../../Components/NoRecord/NoRecord";
import { toast } from "react-toastify";
import { AddToCart } from "../../redux/actions/CartActions";
import swal from "sweetalert";
import { BsFillCartPlusFill } from "react-icons/bs";

function Wishlist() {
  const dispatch = useDispatch();
  const Token = useSelector((state) => state.AuthReducer.token);
  const userData = useSelector((state) => state.AuthReducer.users);
  const ImageUrlRedux = useSelector((state) => state.AuthReducer.urlData);
  const cartDataRedux = useSelector((state) => state.CartReducer.cartData);

  const [fvtData, setFvtData] = useState([]);
  const [spinLoad, setSpinLoad] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageCount, setPageCount] = useState();
  const [quantity, setQuantity] = useState(1);
  const [selectVariation, setSelectVariation] = useState();

  const handlePageClick = async (data) => {
    setCurrentPage(data?.selected + 1);
  };

  //Get wishlist Data
  useEffect(() => {
    setSpinLoad(true);
    GetAllWishList(currentPage, Token)
      .then((res) => {
        setFvtData(res?.data?.data);
        const total = res?.data?.total;
        const limit = res?.data?.per_page;
        setPageCount(Math.ceil(total / limit));
        setSpinLoad(false);
      })
      .catch((err) => {
        setSpinLoad(false);
      });
  }, [currentPage]);

  const DeleteWishListHandler = (id, index) => {
    setSpinLoad(true);
    let data = {
      product_id: id,
      _method: "delete",
    };
    swal({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this product!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        PostWishListDelete(data, Token)
          .then((res) => {
            setSpinLoad(false);
            setFvtData((preval) =>
              preval.filter((val) => val?.product?.id != id)
            );
          })
          .catch((err) => {
            setSpinLoad(false);
          });
      } else {
        swal("Your product is safe!");
        setSpinLoad(false);
      }
    });
  };

  const AddToCartHandler = (item) => {
    let checkItemAlreadyExist = cartDataRedux.filter(
      (val) => val?.id === item?.id
    );
    if (!selectVariation) {
      toast.info("Please Select Product Variation");
      return;
    }
    let variationQty = item?.variation?.filter(
      (val) => val?.size == selectVariation
    );
    if (variationQty?.length > 0 && variationQty[0]?.qty < 1) {
      toast.info("selected Product variant is out of stock");
      return;
    }
    if (checkItemAlreadyExist.length > 0) {
      swal({
        title: "Item Already Exist in Cart!!!",
      });
    } else {
      let data = {
        id: item?.id,
        price:
          item?.variation && item?.variation?.length > 0
            ? item?.variation[0]?.price
            : " ",
        quantity: quantity,
        size:
          item?.variation && item?.variation?.length > 0
            ? item?.variation[0]?.size
            : " ",
        campaign_price: "",
        campaign_id: "",
        productitem: item,
        deliveryDate: " ",
        addon_item: "",
        // addon_id: "",
        product_variant_id: variationQty[0]?.id ? variationQty[0]?.id : "",
        addon_variant_id: "",
        addon_variationPrice: "",
        addonQuantity: "",
      };
      dispatch(AddToCart(data));
      toast("Product successfully added");
      setSpinLoad(true);
      let dataDelete = {
        product_id: item?.id,
        _method: "delete",
      };
      PostWishListDelete(dataDelete, Token)
        .then((res) => {
          setSpinLoad(false);
          setFvtData((preval) =>
            preval.filter((val) => val?.product?.id != item?.id)
          );
        })
        .catch((err) => {
          setSpinLoad(false);
        });
    }
  };

  return (
    <>
      <Header />

      {/* <!-- Universal Banner Sec End Here --> */}
      <section className="profile">
        <div className="container">
          <div className="row profile-row">
            <SideBar />
            <div className="col-lg-9">
              <div className="tab-content" id="v-pills-tabContent">
                <div
                  className="tab-pane fade active show"
                  id="pills-home"
                  role="tabpanel"
                  aria-labelledby="pills-home-tab"
                >
                  <TopBar />

                  <div className="row">
                    <div className="col-lg-12 ">
                      <h3 className="form-heading heading-top-cont">
                        Wishlist
                      </h3>
                      {spinLoad ? (
                        <>
                          {[0, 1, 2, 3, 4, 5, 7, 8, 9]?.map((item, index) => {
                            return (
                              <div className="col-md-12 mt-3" key={index}>
                                <Skeleton count={5} />
                              </div>
                            );
                          })}
                        </>
                      ) : (
                        <>
                          {fvtData?.length > 0 ? (
                            <>
                              <div className="order-table-wrapper table-responsive">
                                <table>
                                  <tbody>
                                    <tr className="row1">
                                      <th className="order-no"></th>
                                      <th className="order-no">Product Name</th>
                                      {/* <th className="order-date">Detail</th> */}
                                      <th className="order-status">Price</th>
                                      {/* <th className="order-status">SUBTOTAL</th> */}
                                      <th className="order-pay">Add to Cart</th>
                                      <th className="order-pay">Remove</th>
                                    </tr>
                                    {fvtData?.map((item, index) => {
                                      return (
                                        <>
                                          <tr className="row2" key={index}>
                                            <td className="number">
                                              <img
                                                src={
                                                  item?.product?.thumbnail
                                                    ? `${ImageUrlRedux?.product_thumbnail_url}/${item?.product?.thumbnail}`
                                                    : no_image_product_details
                                                }
                                                alt=""
                                                className="image-fluid img_whishlist_hoho"
                                              />
                                            </td>
                                            <td className="date ">
                                              <div className="txt_one_line_elipses">
                                                {item?.product?.name}
                                              </div>
                                              <div>
                                                <select
                                                  className="form-control"
                                                  id="Amount"
                                                  onChange={(e) =>
                                                    setSelectVariation(
                                                      e.target.value
                                                    )
                                                  }
                                                >
                                                  <option
                                                    value=""
                                                    selected
                                                    disabled
                                                  >
                                                    Select Variation
                                                  </option>
                                                  {item?.product?.variation?.map(
                                                    (item, index) => {
                                                      return (
                                                        <option
                                                          value={item?.size}
                                                          key={index}
                                                        >
                                                          {item?.size}
                                                        </option>
                                                      );
                                                    }
                                                  )}
                                                </select>
                                              </div>
                                            </td>
                                            {/* <td className="date">
                                             
                                               {item?.product?.leaf_type}
                                            </td> */}
                                            <td className="paid confirm">
                                              $
                                              {item?.product?.variation &&
                                              item?.product?.variation?.length >
                                                0
                                                ? item?.product?.variation[0]
                                                    ?.price
                                                : item?.product
                                                    ?.unit_price}{" "}
                                            </td>
                                            <td className="order-details">
                                              <button className="wishlist-add-btn mr-3">
                                                <BsFillCartPlusFill
                                                  className="wishlist-add-icon "
                                                  onClick={(e) =>
                                                    AddToCartHandler(
                                                      item?.product
                                                    )
                                                  }
                                                />
                                              </button>
                                            </td>
                                            <td className="order-details">
                                              <FontAwesomeIcon
                                                onClick={(e) =>
                                                  DeleteWishListHandler(
                                                    item?.product?.id,
                                                    index
                                                  )
                                                }
                                                className="cursor_pointer"
                                                icon={faXmark}
                                              />
                                            </td>
                                          </tr>
                                        </>
                                      );
                                    })}
                                  </tbody>
                                </table>
                              </div>
                            </>
                          ) : (
                            <NoRecord />
                          )}
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}

export default Wishlist;
